import { Typography } from "@mui/material";
import AdminLayout from "Layout/Admin";

function AdminTransactions() {
    return (<AdminLayout>
        <Typography>Admin Transactions</Typography>
    </AdminLayout>);
}

export default AdminTransactions;